/* eslint-disable no-unused-vars */
export enum routeEnum {
  NotFound = "/404",
  FallBack = "*",
  Home = "/",
  OrganisationInfo = "/organisation-info/:clubId",
  ResetPassword = "/auth/register/reset-password/:userId/:verificationCode",
  UserInfo = "/user",
  InvitationExpiry = "invitationExpiry",
  VerifyInvitation = "auth/register/verify-invitation/:invitationId",
  Info = "info",
  CookiePolicy = "cookie-policy",
  KioskInstall = "/kiosk/install",
  BookingShare = "/booking/detail/:bookingId",
}

export enum kioskRouteEnum {
  Login = "/login",
  Booking = "/",
  Install = "/install",
  Landing = "/landing",
  DeviceError = "/device-error",
}

export enum organisationEnum {
  Booking = "booking",
  ContactPerson = "/contact-person",
  EditBooking = "booking/edit/:bookingId",
  Info = "info",
}

export enum supportEnum {
  Auth = "/auth/register/verify-email/",
  Booking = "/booking",
  ContactPerson = "/contact-person",
  Info = "/info",
  Member = "/user/member",
  OrganisationInfo = "/organisation-info",
  Reservations = "/user/reservations",
  Units = "/units",
  UserInfo = "/user/info",
  loginUser = "/login",
  refresh = "/login/refresh",
}

export enum userInfoEnum {
  Info = "info",
  Member = "member",
  Organizations = "organizations",
  Reservations = "reservations",
  KioskSetup = "kiosk",
  UserInfo = "user/info",
  PaymentMethods = "payment-methods",
}

export const route = { routeEnum };
